<template>
  <div class="login m-auto" style="max-width:40%;">
    <div class="form-group">
      <label class="login-title">{{$t('account')}}</label>
      <input type="account" v-model="username" class="form-control" placeholder="請輸入帳號">
    </div>
    <div class="form-group">
      <label class="login-title mt-4">{{$t('password')}}</label>
      <input type="password" v-model="password" class="form-control" placeholder="請輸入密碼">
    </div>
    <button type="submit" @click="login(username,password)" class="btn btn-primary">{{$t('login')}}</button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'login',
  data () {
    return {
      username: '',
      password: ''
    }
  },
  computed: {
    ...mapGetters(['token'])
  },
  mounted () {
    if (window.localStorage.getItem('login')) {
      this.$router.replace({
        name: 'exam.editor'
      })
    }
  },
  methods: {
    async login (username, password) {
      await this.$store.dispatch('login', { username, password })
      if (this.token) {
        this.$router.push({ name: 'home' })
      } else {
        alert('請輸入正確帳號密碼')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  margin-top: 20vh !important;
}
.login-title {
  font-weight: bold;
  font-size: 2rem;
}
.form-control{
  outline: none;
  border-radius: 50px;
}
.form-control:focus {
  border-color: rgb(185, 185, 185);
  box-shadow: 3px 2px 5px #888888;
}
</style>
